import React, { Component, createRef } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { profile } from '../../stores/storages/ProfileStorage';
import formatter from '../../services/formatter';
import Helpers from '../../lib/helpers';

const messages = defineMessages({
  e2e_get_pre_key_from_mobile_title: {
    id: "e2e_get_pre_key_from_mobile_title",
    defaultMessage: "Security code",
    description: "Security code",
  },
  e2e_get_pre_key_from_mobile_description: {
    id: "e2e_get_pre_key_from_mobile_description",
    defaultMessage: "Please enter the security code for the message sent to the Mocha app from the Mocha official account",
    description: "Please enter the security code for the message sent to the Mocha app from the Mocha official account",
  },
  e2e_retry: {
    id: "e2e_retry",
    defaultMessage: "Didn't get a security code? Resend security code.",
    description: "Didn't get a security code? Resend security code.",
  },
  e2e_get_pre_key_from_mobile_ok_text: {
    id: "e2e_get_pre_key_from_mobile_ok_text",
    defaultMessage: "Confirm",
    description: "Confirm",
  },
  e2e_get_pre_key_from_mobile_success: {
    id: "e2e_get_pre_key_from_mobile_success",
    defaultMessage: "Successful confirmation",
    description: "Successful confirmation",
  },
  e2e_get_pre_key_from_mobile_empty_password: {
    id: "e2e_get_pre_key_from_mobile_wrong_password",
    defaultMessage: "You haven’t entered the message security code. Please enter to complete the Mocha PC login process",
    description: "You haven’t entered the message security code. Please enter to complete the Mocha PC login process",
  },
  e2e_get_pre_key_from_mobile_wrong_password: {
    id: "e2e_get_pre_key_from_mobile_empty_password",
    defaultMessage: "Security code not match",
    description: "Security code not match",
  }
});

class OtpInput extends Component {
  constructor(props) {
    super(props);
    const length = props.length || 6;
    this.state = {
      otp: Array(length).fill(''),
      resendCountdown: 0,
    };
    this.inputRefs = Array(length)
      .fill()
      .map(() => createRef());
    this.resendTimer = null;
  }

  componentWillUnmount() {
    clearInterval(this.resendTimer);
  }

  get isValidOtpLength() {
    return this.state.otp.every((char) => char !== '');
  }

  handleChange = (value, index) => {
    if (!/^[0-9a-zA-Z]?$/.test(value)) return;

    const { otp } = this.state;
    const newOtp = [...otp];
    newOtp[index] = value;

    this.setState({ otp: newOtp }, () => {
      if (value && index < this.inputRefs.length - 1) {
        this.inputRefs[index + 1].current.focus();
      }
    });
  };

  handleKeyDown = (e, index) => {
    const { otp } = this.state;

    if (e.key === 'Backspace') {
      if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = '';
        this.setState({ otp: newOtp });
      } else if (index > 0) {
        this.inputRefs[index - 1].current.focus();
      }
    }

     // Nhấn Enter thì xác nhận nếu đủ
    if (e.key === 'Enter') {
      this.confirmOtp();
    }
  };

  confirmOtp = () => {
    const { otp } = this.state;
    if (this.isValidOtpLength) {
      const { username, token, preKeyInfo } = profile;
      
      const password = otp.join('');
      const key = `${username}${token}${preKeyInfo.timestamp}${password}`

      if (formatter._encryptMD5(key) !== preKeyInfo.md5) {
        Helpers.showErrorToasts(
          this.props.intl.formatMessage(messages.e2e_get_pre_key_from_mobile_empty_password),
        );
        return this.setState({
          otp: Array(this.inputRefs.length).fill('')
        });
      }

      const privKey = formatter.xxteaDecrypt(preKeyInfo.pri, key);
      const pubKey = formatter.xxteaDecrypt(preKeyInfo.pub, key);
      preKeyInfo.isDecrypted = true;
      preKeyInfo.privKey = privKey;
      preKeyInfo.pubKey = pubKey;
      preKeyInfo.isTransferKeySuccess = true;
      profile.preKeyInfo = preKeyInfo;
      localStorage.setItem('prekey_decrypt_key', otp.join(''));
      this.props.tinode.isWaitKeyFromMobile = false;
      this.props.onClose();
      Helpers.showSuccessToasts(
        this.props.intl.formatMessage(messages.e2e_get_pre_key_from_mobile_success),
      );
    }
  };

  handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData('text').slice(0, this.inputRefs.length);
    const chars = paste.split('');
    const newOtp = [...this.state.otp];

    chars.forEach((char, i) => {
      if (i < newOtp.length) newOtp[i] = char;
    });

    this.setState({ otp: newOtp });
  };

  onClickRequestGetKeyFromMobile = () => {
    if (this.state.resendCountdown > 0) return;
    this.props.tinode.getKeyFromMobile();

    this.setState({ resendCountdown: 60 }, () => {
      this.resendTimer = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.resendCountdown <= 1) {
            clearInterval(this.resendTimer);
            return { resendCountdown: 0 };
          }
          return { resendCountdown: prevState.resendCountdown - 1 };
        });
      }, 1000);
    });
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { otp } = this.state;

    return (
      <div className="dialog-content dialog-mobile-password">
        <div className="header">
          <div className="title">
            {formatMessage(messages.e2e_get_pre_key_from_mobile_title)}
          </div>
        </div>
        <div className="content">
          <div className="description">{formatMessage(messages.e2e_get_pre_key_from_mobile_description)}</div>
          <div className="otp-input" onPaste={this.handlePaste}>
            {otp.map((value, index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                value={value}
                ref={this.inputRefs[index]}
                onChange={(e) => this.handleChange(e.target.value, index)}
                onKeyDown={(e) => this.handleKeyDown(e, index)}
                className="otp-box"
              />
            ))}
          </div>
          <div className={`retry ${this.state.resendCountdown && 'disabled'}`} onClick={this.onClickRequestGetKeyFromMobile}>{formatMessage(messages.e2e_retry)}{ this.state.resendCountdown ? `(${this.state.resendCountdown}s)` : '' }</div>
          <div className="__action">
            {/* <button
              className="btn-cancel"
              onClick={() => this.onClickHandleInviteMembersToNewFeature()}
            >
              { formatMessage(messages.e2e_get_pre_key_from_mobile_ok_text) }
            </button> */}
            <button
              className={`btn-ok ${!this.isValidOtpLength && 'btn-disabled'}`}
              onClick={this.confirmOtp}
            >
              { formatMessage(messages.e2e_get_pre_key_from_mobile_ok_text) }
            </button>
          </div>

        </div>
      </div>
    )

  }
}

export default injectIntl(OtpInput);
